import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const urlCleanup = (url) => {
  return url
    .replace(/-/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

const formatPaths = (arr) => {
  let newArr = new Array(...arr)

  const safetyNowIndex = arr.indexOf('safety-now');
  if (safetyNowIndex !== -1) {
    newArr = arr.slice(0, safetyNowIndex+3);
  }

  return newArr;
}

const Breadcrumbs = () => {
  const location = useLocation();
  
  const breadcrumbs = React.useMemo(() => {
    const pathArray = formatPaths(location.pathname.split('/').filter(Boolean))
    const crumbs = [];
    let accumulatedPath = '';
    
    pathArray.forEach((segment) => {
      if (segment === 'chemical-profile') return; // Skip this segment
      accumulatedPath += '/' + segment;
      // Replace hyphens with spaces and capitalize
      const label = urlCleanup(decodeURIComponent(segment));

      crumbs.push({
        label,
        path: accumulatedPath
      });
    });
    
    // Add Home as the first breadcrumb
    return [
      { label: 'Home', path: '/' },
      ...crumbs
    ];
  }, [location.pathname]);

  return (
    <nav aria-label="breadcrumb" className="breadcrumbs mx-auto">
      <ol className="list-none flex gap-2 p-8 m-0 flex-wrap">
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={`crumb-${index}`}>
            <li className="relative">
              {index !== breadcrumbs.length - 1 ? (
                <Link
                  to={crumb.path}
                  className="no-underline text-blue-600 hover:text-blue-800"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-gray-600">{crumb.label}</span>
              )}
            </li>
            {index !== breadcrumbs.length - 1 && (
              <li className="relative">
                <span className="text-gray-400">/</span>
              </li>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
